import { useTranslation } from 'react-i18next';
import type { UseDrawingDocumentResult } from '../../hooks/useDrawingDocument';

/**
 * #705 -- a molecule above the arrow (the Reagents & catalysts box) is a reagent unless marked a
 * catalyst. Shown in the Edit tab while exactly one such molecule is selected.
 */
export function ReactionAgentRoleSection({ doc }: { readonly doc: UseDrawingDocumentResult }) {
  const { t } = useTranslation();
  const selected = new Set(doc.selection.atomIds);
  const molecule = doc.reactionMolecules.find(
    (candidate) =>
      candidate.zone === 'above' &&
      candidate.atomIds.length === selected.size &&
      candidate.atomIds.every((id) => selected.has(id))
  );
  if (!molecule) return null;
  const catalyst = doc.isCatalyst(molecule.atomIds);

  return (
    <section className="rail-section" aria-labelledby="reaction-agent-role-heading" data-testid="reaction-agent-role">
      <h2 id="reaction-agent-role-heading">{t('reactionAgentRole.heading')}</h2>
      <div className="reaction-agent-role-choices">
        {(['reagent', 'catalyst'] as const).map((role) => {
          const pressed = (role === 'catalyst') === catalyst;
          return (
            <button
              key={role}
              type="button"
              className={`reaction-agent-role-choice ${pressed ? 'active' : ''}`}
              aria-pressed={pressed}
              onClick={() => doc.setCatalyst(molecule.atomIds, role === 'catalyst')}
            >
              {t(`reactionAgentRole.${role}`)}
            </button>
          );
        })}
      </div>
    </section>
  );
}
